define('plugin/location/LocationPlugin',['require','lib/plugin/PluginAbstract','plugin/location/collection/LocationCollection','plugin/location/step/LocationStep','Config'],function (require) {
	
	var PluginAbstract = require('lib/plugin/PluginAbstract');
	var LocationCollection = require('plugin/location/collection/LocationCollection');
	var LocationStep = require('plugin/location/step/LocationStep');
	var Config = require('Config');

	return PluginAbstract.extend({
		
		_collection: null,
		_bookingModel: null,
		
		initialize: function () {
			this._collection = new LocationCollection();
		},

		/**
		 * On step manager inits, add events.
		 * On init steps add filters and comparators
		 */
		initStepManagerEvents: function () {
            this._collection.resetFilters();
            
			this._bookingModel = this._stepManager.getBookingModel();

			this.listenTo(this._stepManager, 'step:init:provider', this.addProviderFilter);
			this.listenTo(this._stepManager, 'step:init:service', this.addServiceFilter);
			this.listenTo(this._stepManager, 'step:init:category', this.addCategoryFilter);
			this.listenTo(this._bookingModel, 'change:provider_id', this.onProviderChanged);
			this.listenTo(this._collection, 'sync', this.onDataFetch);
		},

		/**
		 * Adds location step
		 * 
		 * @param Array steps
		 * @return Array|null
		 */
		modifySteps: function (steps) {
			steps.unshift('location');
			return steps;
		},
		
		/**
		 * Returns plugin step object
		 * 
		 * @see lib/controller/booking/BaseStep
		 * @param String step - step name
		 * @param Object params - step parameters
		 * @return BaseStep|null
		 */
		getStep: function (step, params) {
			if (step === 'location') {
				return new LocationStep(_.extend({
					collection: this._collection
				}, params));
			}
		},

		/**
		 * Adds filter and comparator to providers collection
		 *
		 * @param BaseStep step
		 * @param FilterableCollection collection
		 */
		addProviderFilter: function (step, collection) {
			collection.addFilter(_.bind(this.providerFilter, this));
			collection.setComparator(_.bind(this.providerComparator, this));
		},

		/**
		 * Provider comparator to sort providers
		 */
		providerComparator: function (model1, model2) {
			if (model1.get('id') === 'any') {
				return -1;
			}
			if (model2.get('id') === 'any') {
				return 1;
			}

			var location = this._collection.get(this._bookingModel.get('location_id'));
			if (location) {
				var units = location.get('units');
				return _.indexOf(units, model1.get('id')) - _.indexOf(units, model2.get('id'));
			}
		},

		/**
		 * Filters provider model
		 * (used to filter provider collection based on service,
		 * selected in this._bookingModel, taking in account 'any_unit' plugin
		 *
		 * @param Backbone.Model
		 * @return Boolean
		 */
		providerFilter: function (model) {
			var location = this._collection.get(this._bookingModel.get('location_id'));
			if (!location) {
				return true;
			}
			if (_.indexOf(location.get('units'), model.get('id')) >= 0) {
				return true;
			}
			if (model.get('id') === 'any') {
				return true;
			}
			return false;
		},

		/**
		 * Adds filter to services collection
		 *
		 * @param BaseStep step
		 * @param FilterableCollection collection
		 */
		addServiceFilter: function (step, collection) {
			collection.addFilter(_.bind(this.serviceFilter, this));
		},

		/**
		 * Filters service model
		 *
		 * @param Backbone.Model
		 * @return Boolean
		 */
		serviceFilter: function (model) {
			var location = this._collection.get(this._bookingModel.get('location_id'));
			if (!location) {
				return true;
			}
			if (_.indexOf(location.get('events'), model.get('id')) >= 0) {
				return true;
			}
			return false;
		},

		/**
		 * Adds filter to categories collection
		 *
		 * @param BaseStep step
		 * @param FilterableCollection collection
		 */
		addCategoryFilter: function (step, collection) {
			collection.addFilter(_.bind(this.categoryFilter, this));
		},

		/**
		 * Filters provider model
		 *
		 * @param Backbone.Model
		 * @return Boolean
		 */
		categoryFilter: function (model) {
			var location = this._collection.get(this._bookingModel.get('location_id'));
			if (!location) {
				return true;
			}
			if (_.indexOf(location.get('categories'), model.get('id')) >= 0) {
				return true;
			}
			return false;
		},


		onProviderChanged : function (model) {
			if(this.isTimelineWithoutLocation()){
				this.selectLocationByProvider();
			}
		},

		onDataFetch : function(){
			if(this.isTimelineWithoutLocation()){
				this.selectLocationByProvider();
			}
		},

		isTimelineWithoutLocation : function () {
			var timeline = Config.getInstance().getOption('timeline_type');
			var timelinesWithoutLocation = [Config.TIMELINE_GRID_WEEKLY];

			if (_.contains(timelinesWithoutLocation, timeline)) {
				return true;
			}
			return false;
		},

		selectLocationByProvider : function () {
			var providerId = this._bookingModel.get('provider_id');

			if(providerId) {
				var acceptedLocationIds = this._collection.filter(function (locationModel) {
					var locationProviders = locationModel.get('units');
					if (_.contains(locationProviders, providerId)) {
						return true;
					}
					return  false;
				}).map(function (model) {
					return model.id;
				});

				if(acceptedLocationIds && acceptedLocationIds.length === 1){ //if only one location
					this._bookingModel.set('location_id', acceptedLocationIds[0]);
					this._bookingModel.set('location', this._collection.getModelObj(acceptedLocationIds[0]));
				}
			}
		},
		
	});
	
});
